<template>
  <div>
    <recherche-motif class="mb-2"></recherche-motif>

    <h3>Catégories</h3>

    <div class="icon-list">
      <div v-for="categorie in categories" :key="categorie.id" class="amsom-button"
           @click="setSelectedCategoryAndRedirectToTypes(categorie.id)">
        <button class="btn btn-primary">
          <i :class="fontawesomeico(categorie.id)"></i>
        </button>
        <span class="amsom-button-libelle">{{ categorie.libelle }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import RechercheMotif from "./RechercheMotif";
import toast from "@/js/toast";
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "Categories",
  components: {RechercheMotif},
  data() {
    return {
      showRecherche: true,
      selectedSollicitation: null,
    }
  },
  computed: {
    ...mapGetters('categories', ['iCanWrite']),
    ...mapGetters('partenaires', ['partenaires']),
    categories() {
      return this.iCanWrite;
    }
  },
  methods: {
    ...mapActions('categories', ['setSelectedCategory']),
    ...mapActions('types', ['setSelectedType']),
    ...mapActions('natures', ['setSelectedNature']),
    ...mapActions('motifs', ['setSelectedMotif']),
    ...mapActions('entrees', ['setSelectedEntree']),
    setSelectedCategoryAndRedirectToTypes(categoryID) {
      this.setSelectedCategory(categoryID)
      this.$router.push({
        name: 'types',
        params: {sollicitation: this.selectedSollicitation}
      });
    },
    fontawesomeico(ID) {
      if (ID === "TECH") return 'fas fa-tools'
      if (ID === "ADMI") return 'far fa-address-card'
      if (ID === "TROU") return 'fas fa-bullhorn'
      if (ID === "GLOC") return 'far fa-building'
      return 'fas fa-cog'
    }
  },
  // computed: {
  //   categories() {
  //     // return JSON.parse(storeCategories.categories)
  //     return this.iCanWrite()
  //   }
  // },
  mounted: function () {
      if (!this.partenaires || this.partenaires=='[]'){
          toast.showToast('error', "Vous n'êtes pas partenaire du patrimoine, saisie de sollicitation impossible");
          this.$router.push({name: 'home'});
      }


    // Obsolète?
    if (typeof this.$route.params.sollicitation !== 'undefined' && this.$route.params.sollicitation !== null) {
      this.selectedSollicitation = this.$route.params.sollicitation
    }
    this.setSelectedCategory(null)
    this.setSelectedType(null)
    this.setSelectedNature(null)
    this.setSelectedMotif(null)
    this.setSelectedEntree(null)
    // if (this.categories.length === 1){
    //   this.setSelectedCategory(this.categories[0].id)
    //   this.$router.push({
    //     name: 'types',
    //     params: {sollicitation: this.selectedSollicitation}
    //   });
    // }
  }
}
</script>